import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const AccessBanner = ({ access }) => {
  if (access?.level !== "free") return null;
  return (
    <div
      className={`rounded-xl border px-5 py-4 ${access.free_draft_used ? "border-orange-300 bg-orange-50" : "border-sky-200 bg-sky-50"}`}
      data-testid="research-access-banner"
    >
      {access.free_draft_used ? (
        <>
          <p className="text-sm font-semibold text-orange-900">Free draft used</p>
          <p className="text-xs text-orange-800 mt-1">
            The AI Researcher is included with every subscription plan. Subscribe to keep generating and revising grounded drafts.
          </p>
          <Button asChild size="sm" className="mt-3 bg-orange-600 hover:bg-orange-700 text-white" data-testid="research-upgrade-btn">
            <Link to="/subscriptions">View plans</Link>
          </Button>
        </>
      ) : (
        <p className="text-xs text-sky-900">
          <span className="font-semibold">You have 1 free draft.</span> Try the AI Researcher — subscribing to any plan unlocks daily drafts and AI revisions.
        </p>
      )}
    </div>
  );
};
